module.exports = "/fonts/vendor/@fontsource/inter/files/inter-latin-ext-100-normal.woff2?2407e03f5c6fecbbbb96bb99095ce74d";